import { useMutation } from '@tanstack/react-query'

import { postFaceToFaceKycRequest } from '@src/api'
import { DefaultApiPostFaceToFaceKycRequestRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const usePostFaceToFaceKycRequest = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiPostFaceToFaceKycRequestRequest) =>
      postFaceToFaceKycRequest(axiosInstance, params),
  })
}
